/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface ClaimGuildQuestResponse
 */
export interface ClaimGuildQuestResponse {
    /**
     * 
     * @type {Array<RewardResponseObject>}
     * @memberof ClaimGuildQuestResponse
     */
    rewards: Array<RewardResponseObject>;
}

/**
 * Check if a given object implements the ClaimGuildQuestResponse interface.
 */
export function instanceOfClaimGuildQuestResponse(value: object): value is ClaimGuildQuestResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function ClaimGuildQuestResponseFromJSON(json: any): ClaimGuildQuestResponse {
    return ClaimGuildQuestResponseFromJSONTyped(json, false);
}

export function ClaimGuildQuestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimGuildQuestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
    };
}

export function ClaimGuildQuestResponseToJSON(json: any): ClaimGuildQuestResponse {
    return ClaimGuildQuestResponseToJSONTyped(json, false);
}

export function ClaimGuildQuestResponseToJSONTyped(value?: ClaimGuildQuestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(RewardResponseObjectToJSON)),
    };
}

